//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import filtersCam from '~/mixins/filtersCam.js';

export default {
  name: 'filtersListMobile',
  mixins: [filtersCam],
  computed: {
    ...mapState({
      camFilter: ({ camStore: { camFilter } }) => camFilter,
    }),
  },
  methods: {
    async resetFilters() {
      this.$store.commit('camStore/resetFilters');
      await this.$store.dispatch('camStore/getCams', this.camsQuery);
      this.$emit('close');
    },
    showResults() {
      this.$emit('close');
    },
  },
};
